import { z } from 'zod';

import type { LSG_RUN_STATUS, LSG_RUN_VISIBILITY } from '../dictionary';

export const LsgReportIdSchema = z.number();
export type LsgReportId = z.infer<typeof LsgReportIdSchema>;

/** Union of LSG run status values, e.g. "running" | "finished". */
export type LSGRunStatus = (typeof LSG_RUN_STATUS)[keyof typeof LSG_RUN_STATUS];
/** Union of LSG run visibility values, e.g. "active" | "archived". */
export type LSGRunVisibility = (typeof LSG_RUN_VISIBILITY)[keyof typeof LSG_RUN_VISIBILITY];
